<template>
  <div class="breadcrumb">
    <div>
      <el-breadcrumb separator=">">
        <el-breadcrumb-item>{{ levelList.meta.title }}</el-breadcrumb-item>
        <template v-for="child in levelList.children">
          <el-breadcrumb-item
            :key="child.path"
            v-if="!child.hidden"
            :class="{ active: child.path === $route.fullPath }"
            :to="child.path"
            >{{ child.meta.title }}
          </el-breadcrumb-item>
        </template>
      </el-breadcrumb>
    </div>
    <div
      class="closeCurrntPage"
      v-show="$route.path.search('completeStock') !== -1"
      @click="closeCurrntPage"
    >
      X关闭当前页
    </div>
    <div
      v-if="!isZhifaOrFactory"
      class="after-sale-head-info"
      v-show="$route.path.search('afterSale/manage') !== -1"
    >
      退货：在货物签收完毕24小时内，您需要对其售后单做售后确认，若超时未确认的，客服有权做售后确认处理，若有异议或疑问，请及时联系客服
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      levelList: null,
      isZhifaOrFactory:
        localStorage.getItem("shop_type") === "1" ||
        localStorage.getItem("shop_type") === "2",
    };
  },
  computed: {
    ...mapGetters(["permission_routes"]),
  },
  watch: {
    $route(route) {
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      let routes = this.permission_routes;
      routes = JSON.parse(JSON.stringify(routes));
      let matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      );
      const first = matched[0];
      let list = routes.find((item) => {
        return item.path === first.path;
      });
      let child = list.children;
      child = child.filter((item) => {
        return !item.hidden;
      });
      let path = /(\/.*(?=\/))|(\/.*$)/gi.exec(this.$route.path)[0];
      let route = child.find((item) => {
        return item.path === this.$route.path;
      });
      let children = [];
      if (route) {
        children = route;
      } else {
        children = child.find((item) => {
          return item.path.includes(path);
        });
      }
      list.children = [children];
      this.levelList = list;
    },
    isDashboard(route) {
      const name = route && route.name;
      if (!name) {
        return false;
      }
      return name.trim().toLocaleLowerCase() === "order".toLocaleLowerCase();
    },
    closeCurrntPage() {
      if (localStorage.getItem("is_jgj") === "1") {
        // 为紧固件的时候
        this.$router.push("/order/manageFastener");
      } else {
        this.$router.push("/order/manage");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
<style lang="scss">
.breadcrumb {
  position: fixed;
  top: 48px;
  bottom: 0;
  width: 100%;
  background-color: #f5f7fa;
  z-index: 1;
  padding: 11px 0px 0 188px;
  .el-breadcrumb__item.active .el-breadcrumb__inner.is-link {
    color: #ff6224 !important;
    font-weight: 700 !important;
  }
  .el-breadcrumb__inner a,
  .el-breadcrumb__inner.is-link {
    font-weight: 400 !important;
  }
  .el-breadcrumb__item:last-child .el-breadcrumb__inner.is-link {
    cursor: pointer;
  }
  .el-breadcrumb__inner.is-link:hover {
    color: #ff6224;
    font-weight: 700 !important;
  }
  .closeCurrntPage {
    border-radius: 10px;
    border: 1px solid #dcdfe6;
    cursor: pointer;
    font-size: 14px;
    position: fixed;
    right: 16px;
    top: 53px;
    text-align: center;
    width: 94px;
    height: 20px;
    border-radius: 5px;
    background-color: white;
  }
}
.after-sale-head-info {
  position: fixed;
  right: 16px;
  top: 55px;
  font-size: 12px;
  color: #ff6224;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/common/breadcrumb/index.vue